<template>
    <div v-if="length > 1" :style="`height: ${height};`">
        <div class="pagination" :class="[{ 'float-right': !noRight && !center }, { center }]">
            <button class="page-btn nav" :disabled="page <= 1" @click="goTo(page - 1)">&lsaquo;</button>
            <template v-for="(item, i) in pages">
                <span v-if="item === '...'" :key="`e${i}`" class="page-ellipsis">…</span>
                <button v-else :key="`p${i}`" class="page-btn" :class="{ active: item === page }"
                    @click="goTo(item)">{{ item }}</button>
            </template>
            <button class="page-btn nav" :disabled="page >= length" @click="goTo(page + 1)">&rsaquo;</button>
        </div>
    </div>
</template>

<script>
export default {
    name: "KimsaPagination",
    props: {
        height: {
            type: String,
            default: 'auto'
        },
        pageCount: {
            type: [Number, String],
            default: 1,
        },
        totalVisible: {
            type: [Number, String],
            default: 7,
        },
        noRight: {
            type: Boolean,
            default: false
        },
        center: {
            type: Boolean,
            default: false
        },
        value: {
            type: [Number, String],
            default: 1,
        }
    },
    data() {
        return {
            page: 1,
        }
    },
    computed: {
        length(vm = this) {
            return Math.max(1, Number(vm.pageCount) || 1)
        },
        pages(vm = this) {
            const total = vm.length
            const visible = Math.max(5, Number(vm.totalVisible) || 7)
            if (total <= visible) return Array.from({ length: total }, (_, i) => i + 1)

            const current = vm.page
            const result = [1]
            const left = Math.max(2, current - 1)
            const right = Math.min(total - 1, current + 1)
            if (left > 2) result.push('...')
            for (let i = left; i <= right; i++) result.push(i)
            if (right < total - 1) result.push('...')
            result.push(total)
            return result
        }
    },
    methods: {
        goTo(target) {
            const vm = this
            const next = Math.min(vm.length, Math.max(1, target))
            if (next === vm.page) return
            vm.page = next
        }
    },
    watch: {
        page(val) {
            this.$emit('page', val)
        },
        value(val) {
            const newVal = Number(val) || 1
            if (newVal !== this.page) this.page = newVal
        },
    }
}
</script>

<style scoped>
.pagination {
    display: flex;
    align-items: center;
    gap: 3px;
}

.pagination.center {
    justify-content: center;
}

.page-btn {
    min-width: 32px;
    height: 32px;
    border-radius: 6px;
    border: 1px solid transparent;
    background: transparent;
    font-size: 13px;
    font-weight: 500;
    color: var(--v-txtSecondary-base);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 6px;
    transition: background 0.12s, color 0.12s;
}

.page-btn:hover {
    background: var(--v-surface2-base);
    color: var(--v-txtPrimary-base);
}

.page-btn:disabled {
    opacity: 0.4;
    cursor: default;
}

.page-btn:disabled:hover {
    background: transparent;
    color: var(--v-txtSecondary-base);
}

.page-btn.nav {
    color: var(--v-txtMuted-base);
    font-size: 18px;
}

.page-btn.nav:not(:disabled):hover {
    color: var(--v-txtPrimary-base);
}

.page-btn.active {
    background: rgba(51, 153, 153, 0.12);
    color: var(--v-accent-base);
    font-weight: 800;
    border-color: rgba(51, 153, 153, 0.4);
}

.theme--dark .page-btn.active {
    background: linear-gradient(135deg, rgba(204, 255, 51, 0.15), rgba(51, 153, 153, 0.15));
    color: var(--v-primary-base);
    border-color: rgba(204, 255, 51, 0.5);
}

.page-ellipsis {
    font-size: 13px;
    color: var(--v-txtMuted-base);
    padding: 0 4px;
    user-select: none;
}

@media (max-width: 600px) {
    .page-btn {
        min-width: 28px;
        height: 28px;
        font-size: 12px;
        padding: 0 4px;
    }
}
</style>
